<button nz-button nzType="text" nzShape="circle" (click)="click()">
    <nz-icon nzType="edit"></nz-icon>
</button>
